import { createActions, createReducer } from 'reduxsauce';
import {
  BASE_INITIAL_STATE,
  PAGINATED_ACTIONS_SET,
  getRequestHandler,
  getSuccessListHandler,
  getFailureHandler,
} from '../../../store/structures';

const { Types, Creators } = createActions(
  {
    getBusinessesList: ['params'],
    ...PAGINATED_ACTIONS_SET,
  },
  { prefix: 'cb/referrals/businesses/' },
);

export { Types as types, Creators as actions };

export const HANDLERS = {
  [Types.REQUEST]: getRequestHandler(BASE_INITIAL_STATE),
  [Types.SUCCESS]: getSuccessListHandler(),
  [Types.SUCCESS_PAGINATED]: getSuccessListHandler({ attach: true }),
  [Types.FAILURE]: getFailureHandler(),
};

export default createReducer(BASE_INITIAL_STATE, HANDLERS);
